import type { WaveDayDto } from '../../../contracts/cycles'
import { sealColor } from '../../colors'

/**
 * Волна тринадцати дней: точка на день, цвет — печать этого дня. Сегодняшний
 * день крупнее и в золотом кольце, «свои» дни (кин связан с натальным) помечены
 * точкой под кружком, дни вне счёта волны — полым кружком.
 *
 * Рисуем ровно то, что уже посчитал сервер: порядок дней — порядок массива.
 */
const FIELD_WIDTH = 300
const FIELD_HEIGHT = 62
const MARGIN = 14
const ROW_Y = 26

export function WaveStrip({ days }: { days: WaveDayDto[] }) {
  if (days.length === 0) return null
  const step = days.length > 1 ? (FIELD_WIDTH - MARGIN * 2) / (days.length - 1) : 0

  return (
    <svg
      className="viz viz-wave"
      viewBox={`0 0 ${FIELD_WIDTH} ${FIELD_HEIGHT}`}
      width="100%"
      role="img"
      aria-label={`Волна из ${days.length} дней`}
    >
      <line
        x1={MARGIN}
        y1={ROW_Y}
        x2={FIELD_WIDTH - MARGIN}
        y2={ROW_Y}
        style={{ stroke: 'var(--line2)' }}
        strokeWidth={1.5}
      />
      {days.map((day, index) => {
        const x = MARGIN + step * index
        const color = sealColor(day.seal)
        const radius = day.isToday ? 8 : 5.5
        return (
          <g key={day.date}>
            {day.isToday && (
              <circle cx={x} cy={ROW_Y} r={13} fill="none" style={{ stroke: 'var(--gold)' }} strokeWidth={1.5} />
            )}
            <circle
              cx={x}
              cy={ROW_Y}
              r={radius}
              style={
                day.outOfCount
                  ? { fill: 'transparent', stroke: color, opacity: 0.65 }
                  : { fill: color, stroke: color }
              }
              strokeWidth={1.5}
            />
            {day.mine && <circle cx={x} cy={ROW_Y + 14} r={2.2} style={{ fill: 'var(--gold)' }} />}
          </g>
        )
      })}
      <text x={MARGIN} y={FIELD_HEIGHT - 4} textAnchor="middle" className="viz-cap">
        1
      </text>
      <text x={FIELD_WIDTH - MARGIN} y={FIELD_HEIGHT - 4} textAnchor="middle" className="viz-cap">
        {days.length}
      </text>
    </svg>
  )
}
